// VideoEmbed renders an allowlisted provider video as a responsive 16:9 lazy
// iframe. It renders whatever embed URL it is handed — for stored videos that
// is the server-derived embed_url; for the create/edit preview it is the URL
// the client parser derives from the not-yet-saved input. An empty embedUrl
// (stale row whose URL no longer matches, or an unparseable preview) renders
// nothing.
export function VideoEmbed({ embedUrl, title }: { embedUrl: string; title?: string }) {
  if (embedUrl === "") {
    return null;
  }
  return (
    <div className="video-embed">
      <iframe
        src={embedUrl}
        title={title !== undefined && title !== "" ? title : "Position video"}
        loading="lazy"
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
